"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalEventServiceGetTicketsBonusMediaResponse = exports.PortalEventServiceGetTicketsBonusMediaRequest = exports.PortalEventServiceGetEventsByBrandIdResponse = exports.PortalEventServiceGetEventsByBrandIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetEventsByBrandIdRequest
 */
class PortalEventServiceGetEventsByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetEventsByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetEventsByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetEventsByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetEventsByBrandIdRequest, a, b);
    }
}
exports.PortalEventServiceGetEventsByBrandIdRequest = PortalEventServiceGetEventsByBrandIdRequest;
PortalEventServiceGetEventsByBrandIdRequest.runtime = protobuf_1.proto3;
PortalEventServiceGetEventsByBrandIdRequest.typeName = "spwn.event.v1.PortalEventServiceGetEventsByBrandIdRequest";
PortalEventServiceGetEventsByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetEventsByBrandIdResponse
 */
class PortalEventServiceGetEventsByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.PortalEvent events = 1;
         */
        this.events = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetEventsByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetEventsByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetEventsByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetEventsByBrandIdResponse, a, b);
    }
}
exports.PortalEventServiceGetEventsByBrandIdResponse = PortalEventServiceGetEventsByBrandIdResponse;
PortalEventServiceGetEventsByBrandIdResponse.runtime = protobuf_1.proto3;
PortalEventServiceGetEventsByBrandIdResponse.typeName = "spwn.event.v1.PortalEventServiceGetEventsByBrandIdResponse";
PortalEventServiceGetEventsByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: portal_common_pb_1.PortalEvent, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetTicketsBonusMediaRequest
 */
class PortalEventServiceGetTicketsBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated string ticket_ids = 2;
         */
        this.ticketIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetTicketsBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetTicketsBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetTicketsBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetTicketsBonusMediaRequest, a, b);
    }
}
exports.PortalEventServiceGetTicketsBonusMediaRequest = PortalEventServiceGetTicketsBonusMediaRequest;
PortalEventServiceGetTicketsBonusMediaRequest.runtime = protobuf_1.proto3;
PortalEventServiceGetTicketsBonusMediaRequest.typeName = "spwn.event.v1.PortalEventServiceGetTicketsBonusMediaRequest";
PortalEventServiceGetTicketsBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.PortalEventServiceGetTicketsBonusMediaResponse
 */
class PortalEventServiceGetTicketsBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.PortalTicketBonusMedia ticket_bonus_media = 1;
         */
        this.ticketBonusMedia = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEventServiceGetTicketsBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEventServiceGetTicketsBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEventServiceGetTicketsBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEventServiceGetTicketsBonusMediaResponse, a, b);
    }
}
exports.PortalEventServiceGetTicketsBonusMediaResponse = PortalEventServiceGetTicketsBonusMediaResponse;
PortalEventServiceGetTicketsBonusMediaResponse.runtime = protobuf_1.proto3;
PortalEventServiceGetTicketsBonusMediaResponse.typeName = "spwn.event.v1.PortalEventServiceGetTicketsBonusMediaResponse";
PortalEventServiceGetTicketsBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_bonus_media", kind: "message", T: portal_common_pb_1.PortalTicketBonusMedia, repeated: true },
]);
//# sourceMappingURL=portal_service_pb.js.map